/**
 * Словарь тегов канбан-карточки. Чтобы добавить новый тег в будущем —
 * добавь поле в BacklogItemTag (в projectStore.ts), запись в BACKLOG_TAGS
 * и строку в ALL_BACKLOG_TAGS.  Всё остальное (бейджи, переключатели,
 * нормализация из legacy-данных) подхватит автоматически.
 */

import type { BacklogItemTag } from '@/store/projectStore';

export interface BacklogTagMeta {
  /** Короткий человеко-читаемый лейбл. */
  label: string;
  /** Основной акцентный цвет — иконка/контур. */
  color: string;
  /** Полупрозрачный фон для бейджа (обычно color + 20–25% alpha). */
  tint: string;
}

export const BACKLOG_TAGS: Record<BacklogItemTag, BacklogTagMeta> = {
  bug: { label: 'Баг', color: '#D0021B', tint: '#D0021B22' },
};

export const ALL_BACKLOG_TAGS: readonly BacklogItemTag[] = ['bug'] as const;

export function isBacklogTag(v: unknown): v is BacklogItemTag {
  return typeof v === 'string' && (ALL_BACKLOG_TAGS as readonly string[]).includes(v);
}

/** Привести массив произвольных значений к списку валидных тегов (с дедупликацией). */
export function sanitizeBacklogTags(raw: unknown): BacklogItemTag[] {
  if (!Array.isArray(raw)) return [];
  const seen = new Set<BacklogItemTag>();
  for (const t of raw) {
    if (isBacklogTag(t)) seen.add(t);
  }
  return Array.from(seen);
}
